import UserGroupEditForm from "./usergroup-edit-form";

export default UserGroupEditForm;